import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta19Model } from './model-consultaSeguimentoPergunta19'

export const convertConsultaSeguimentoPergunta19ToInput = (
  value: ConsultaSeguimentoPergunta19Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_19_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_19_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_19_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_19_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_19_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
